"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromBase64Url = exports.toBase64Url = void 0;
const buffer_1 = require("buffer");
const toBase64Url = (buffer) => {
    if (typeof buffer === 'string') {
        buffer = buffer_1.Buffer.from(buffer);
    }
    return buffer.toString('base64').replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
};
exports.toBase64Url = toBase64Url;
const fromBase64Url = (encoded) => {
    const padLength = 4 - (encoded.length % 4);
    if (padLength < 4) {
        encoded += '='.repeat(padLength);
    }
    encoded = encoded.replace(/\-/g, '+').replace(/_/g, '/');
    return buffer_1.Buffer.from(encoded, 'base64');
};
exports.fromBase64Url = fromBase64Url;
